import { Component } from '@angular/core';

@Component({
  selector: 'app-therapist-my-change-password',
  templateUrl: './therapist-my-change-password.component.html',
  styleUrls: ['./therapist-my-change-password.component.sass'],
  standalone: false
})
export class TherapistMyChangePasswordComponent {}
